import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';

import * as IntegrationActions from './integration.actions';
import { type IntegrationState } from './interfaces';

export const initialState: IntegrationState = {
  integrationJobs: [],
  replayImports: {
    loading: false,
    response: null,
    error: null,
  },
};

const featureIntegrationSelector =
  createFeatureSelector<IntegrationState>('integration');

export const integrationJobsSelector = createSelector(
  featureIntegrationSelector,
  state => state.integrationJobs,
);

export const replayImportsSelector = createSelector(
  featureIntegrationSelector,
  state => state.replayImports,
);

export const integrationReducer = createReducer(
  initialState,
  on(
    IntegrationActions.getIntegrationJobsSuccess,
    (state, { integrationJobs }) => ({
      ...state,
      integrationJobs,
    }),
  ),
  on(IntegrationActions.replayImportsRequest, state => ({
    ...state,
    replayImports: {
      loading: true,
      response: null as any,
      error: null as any,
    },
  })),
  on(IntegrationActions.replayImportsSuccess, (state, { response }) => ({
    ...state,
    replayImports: {
      response,
      loading: false,
      error: null as any,
    },
  })),
  on(IntegrationActions.replayImportsError, (state, { error }) => ({
    ...state,
    replayImports: {
      error,
      loading: false,
      response: null as any,
    },
  })),
  on(IntegrationActions.leaveIntegration, () => initialState),
);
